/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const inventoryConversionResultDataSchema = z.object({
	invoiceId: z.string(),
	totalValue: z.number(),
	itemsConverted: z.number(),
})

export type InventoryConversionResultDataSchema = z.infer<typeof inventoryConversionResultDataSchema>
